import { useEffect, useState } from 'react'
type Props = {
  children: React.ReactNode
}

// IMPORTANT: Use with caution. This component is not intended to fix unnecessary re-renders.
// Allows two animation frames to complete to allow other components to update and re-render before mounting and rendering an expensive component.
const UseWithCautionDeferredRender = ({
  children,
}: Props): null | React.ReactNode => {
  const [shouldRender, setShouldRender] = useState<boolean>(
    process.env.NODE_ENV === 'production' ? false : true,
  )
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          setShouldRender(true)
        })
      })
    }
  }, [])
  return shouldRender ? children : null
}

export default UseWithCautionDeferredRender
